/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPushButtonCellphone: {
  name: 'push-button-cellphone';
  data: string;
} = {
  name: 'push-button-cellphone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 3a1 1 0 1 0-2 0v3H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5V3ZM8 8v3h8V8H8Zm8 5H8v7h8v-7Zm-1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
